import React, { useEffect, useState } from "react";
import { useFormContext } from "react-hook-form";
import {
  getDepartment,
  getDoctors,
} from "../services/EMRServices/emrServices";
import CommonButton from "../../../common/components/Buttons/CommonButton";
import { warningAlert } from "../../../common/components/Toasts/CustomToasts";
import CommonTransactionTable from "../../../common/components/CommonTable/CommonTransactionTable";
import { Tooltip } from "@mui/material";

// import SearchDropdown from "../../../common/components/FormFields/searchDropdown";
import { useEMRGeneralContext } from "../newGeneralEmr/EMRContextGeneral";
import { DeleteIcon } from "./EmrCommonAsset/Asset";
import InputField from "../../../common/components/FormFields/InputField";
import DropdownField from "../../../common/components/FormFields/DropdownField";
import SearchDropdown from "../../../common/components/FormFields/searchDropdown";

export default function Ref(props) {
  const { dataRef, setDataRef } = props;
  const [departmentValue, setDepartmentValue] = useState(null);
  const [doctorValue, setDoctorValue] = useState(null);
  const {
    doctorCoption,
    setdoctorCoption,
    departmentCOption,
    setDepartmentCOption,
  } = props;
  const {
    handleSubmit,
    reset,
    formState: { errors },
    control,
    register,
    setValue,
    watch,
  } = useFormContext();

  let userRole = JSON.parse(localStorage.getItem("loggedUser"));
  
  const handlechange = (e) => {
    if (e?.length > 0) {
      getDepartment(userRole.loginUnitId, e).then((response) => {
        setDepartmentCOption(response.data.result);
      });
    }
  };

  let department = watch("departmentConsultant");

  useEffect(() => {
    if (department?.id > 0) {
      getDoctors(department?.id).then((response) => {
        setdoctorCoption(response.data.result);
      });
    }
  }, [department]);

  let doctor = watch("doctorConsultant");

  let referalNote = watch("referralNote");

  const handleSubmitRef = () => {
    let obj = {
      doctor: doctor?.label,
      doctorId: doctor?.id,
      department: department?.label,
      departmentId: department?.id,
      referralNote: referalNote,
      isPrivate: doctor?.isPrivate,
    };
    let temp = dataRef.some((row) => row.doctor === doctor?.label);
    if (temp === true) {
      warningAlert("Already Present...!");
      setValue("departmentConsultant", null);
      setValue("doctorConsultant", null);
      setValue("referralNote", "");
    } else {
      if (
        doctor !== null &&
        doctor?.label !== undefined &&
        doctor?.label !== null
      ) {
        setDataRef((pre) => [...pre, obj]);
        setValue("departmentConsultant", null);
        setValue("doctorConsultant", null);
        setValue("referralNote", "");
      } else {
        warningAlert("Please fill the referal details");
      }
    }
  };

  function deleteRow(index) {
    const newComplaintsData = [...dataRef];
    newComplaintsData.splice(index, 1);
    setDataRef(newComplaintsData);
  }

  const renderAction = (row, index) => {
    return (
      <div className="flex gap-2">
        <Tooltip title="Delete">
          <button
            type="button"
            onClick={() => {
              deleteRow(index);
            }}
          >
            <DeleteIcon />
          </button>
        </Tooltip>
      </div>
    );
  };

  return (
    <div>
      <div className="flex justify-between bg-[#DEFFD6] rounded-t-md">
        <p className="text-sm font-semibold pl-2 py-1">Cross Referral</p>
        <div className="flex my-auto"></div>
      </div>
      <div className="p-2 border pb-2 relative border-b-[#D9D9D9] border-r-[#D9D9D9] border-l-[#D9D9D9] bg-white rounded-b-md">
        <div className="flex  my-1  gap-2">
          <div className="w-full  ">
            <fieldset
              className="w-full  flex gap-2"
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  e.preventDefault();
                }
              }}
            >
              <SearchDropdown
                name="departmentConsultant"
                placeholder="Department"
                dataArray={departmentCOption}
                handleInputChange={handlechange}
                searchIcon={true}
                isClearable={true}
                menuPlacement="bottom"
              />
            </fieldset>
          </div>
          <div className="w-full ">
            <fieldset
              className="w-full flex gap-2"
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  e.preventDefault();
                }
              }}
            >
              <DropdownField
                menuPlacement="bottom"
                name="doctorConsultant"
                placeholder="Doctor"
                dataArray={doctorCoption}
                isSearchable={true}
                // handleInputChange={handlechangeDoctor}
                searchIcon={true}
                isClearable={true}
              />
            </fieldset>
          </div>
        </div>
        <div className="flex  my-1  gap-2">
          <div className="w-full">
            <fieldset
              className="w-full flex gap-2"
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  e.preventDefault();
                }
              }}
            >
              <InputField control={control} name="referralNote" label="Note" />
            </fieldset>
          </div>
          <div>
            <CommonButton
              label="Add"
              type="button"
              className="bg-customBlue text-white"
              onClick={() => {
                handleSubmitRef();
              }}
            />
          </div>
        </div>

        <div className=" max-h-44 overflow-auto">
          {dataRef.length > 0 ? (
            <CommonTransactionTable
              dataResult={dataRef.map((item) => ({
                Doctor: item.doctor,
                Department: item.department,
                Note: item.referralNote,
              }))}
              highlightRow={false}
              renderActions={renderAction}
              removeHeaders={["departmentId", "doctorId"]}
            />
          ) : null}
        </div>
      </div>
    </div>
  );
}

